import { Component, Mixins, Watch, Prop } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'

import RichTextModel from '../models/richtext'

@Component({
    name: 'rich-text-viewer',
})
export default class RichTextViewer extends Mixins<MixinInterface>() {
    @Prop({ required: true, default: null }) richtext!: null | Record<string, any>

    get parcedRichtext() {
        return new RichTextModel(this.richtext)
    }
}
